<template>
  <div
    class="has-text-centered"
  >
    <div class="steps-container">
      <span
        class="steps-item"
        :class="{ active: activeStep === 'plan' }"
      >
        <span
          class="title is-4"
          :class="{ clickable: planClickable }"
          @click="$emit('plan-clicked')"
        >1. Plan</span>
      </span>
      <span
        class="steps-item"
        :class="{ active: activeStep === 'account' }"
      >
        <span
          class="title is-4"
          :class="{ clickable: accountClickable }"
          @click="$emit('account-clicked')"
        >2. Account</span>
      </span>
      <span
        class="steps-item"
        :class="{ active: activeStep === 'finalize' }"
      >
        <span
          class="title is-4"
          :class="{ clickable: finalizeClickable }"
          @click="$emit('finalize-clicked')"
        >3. Confirm</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnboardingWizadHeader',

  props: {
    accountClickable: Boolean,
    planClickable: Boolean,
    finalizeClickable: Boolean,
    activeStep: {
      default: '',
      validator: function (value) {
        return ['account', 'plan', 'finalize'].indexOf(value) !== -1
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";

.steps-container {
  padding-bottom: 1em;
}
.steps-item {
  padding-right: 1em;
}
.steps-item span {
  color: $grey-light;
}
.steps-item.active span {
  color: $grey-dark;
}
.steps-item {
  .clickable {
    &:hover {
      color: $grey-dark;
      cursor: pointer;
    }
  }
}
</style>
